import { Action } from '@ngrx/store';
import {IMenu} from '../../models/menu.interface';
import {EMenuActions} from './menu.actions';
import {IChannel} from '../../models/channels.interface';

export enum EChannelsActions {
    GetChannels = '[Channels] Get Channels',
    GetChannelsSuccess = '[Channels] Get Channels Success',
    GetChangeChannel = '[Channels] Get Default Change Channel'
}

export class GetChannels implements Action {
  public readonly type = EChannelsActions.GetChannels;
    constructor() {
    }
}

export class GetChangeChannel implements Action {
  public readonly type = EChannelsActions.GetChangeChannel;
    constructor(public payload: boolean) {
    }
}

export class GetChannelsSuccess implements Action {
    public readonly type = EChannelsActions.GetChannelsSuccess;
    constructor(public payload: IChannel[]) {}
}

export type ChannelsActions =
  | GetChangeChannel
  | GetChannels
  | GetChannelsSuccess;

